/** Persistence for the panel's corner (spec section 6.4). Every storage touch is try/catch-wrapped. */
import { CORNERS, DEFAULT_CORNER, STORAGE_KEY, type Corner } from './constants';

export function readCorner(): Corner {
  try {
    const raw = globalThis.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_CORNER;
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return DEFAULT_CORNER;
    const { v, corner } = parsed as { v?: unknown; corner?: unknown };
    if (v !== 1) return DEFAULT_CORNER;
    return CORNERS.find((c) => c === corner) ?? DEFAULT_CORNER;
  } catch {
    return DEFAULT_CORNER;
  }
}

export function writeCorner(corner: Corner): void {
  try {
    globalThis.localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: 1, corner }));
  } catch {
    // Storage unavailable or full: the corner simply is not remembered.
  }
}
